import { Dimensions, StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 19,
  },
  background: theme => ({
    backgroundColor: theme.colors.backgroundColorThree,
    paddingTop: 60,
    paddingHorizontal: 15,
  }),
  textContainerStyle: {
    flex: 1,
    marginLeft: 11,
  },
  descriptionStyle: {
    fontSize: 14.6,
    lineHeight: 18.7,
    marginTop: 16,
    marginLeft: 43,
  },
  titleStyle: {
    fontSize: 18.7,
    lineHeight: 26,
  },
  cardContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 19,
    marginLeft: 43,
  },
  col: theme => ({
    flex: 1,
    height: 44,
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.cardBackground,
    cursor: 'pointer'
  }),
  colSelected: theme => ({
    backgroundColor: theme.colors.activeColor,
    borderRadius: 6,
  }),
  colStart: {
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
  colEnd: {
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
  },
  text: {
    fontSize: 18,
    lineHeight: 28,
    letterSpacing: 0,
    alignSelf: 'center',
  },
  divider: theme => ({
    width: 1,
    height: 46,
    backgroundColor: theme.colors.divider,
    marginHorizontal: Dimensions.get('window').width * 0.022,
  }),
});
